module.exports = __webpack_public_path__ + "img/winnie.02ccc8dc.jpg";